import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const Undo = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  color: "#1976d2",
  "&:hover": {
    color: "#2e7d32",
    backgroundColor: "rgba(46, 125, 50, 0.04)",
  },
}));

export default Undo;
